import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';
  const token = sessionStorage.getItem('access_token');
  const idToken = sessionStorage.getItem('idToken');

  // Require both the authentication flag AND valid tokens from SSO
  if (!isAuthenticated || !token || !idToken) {
    sessionStorage.removeItem('isAuthenticated');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('idToken');
    return <Navigate to="/" replace />;
  }

  // Basic token expiry check
  try {
    const payload = JSON.parse(atob(idToken.split('.')[1]));
    const exp = payload.exp * 1000;
    if (Date.now() > exp) {
      sessionStorage.removeItem('isAuthenticated');
      sessionStorage.removeItem('access_token');
      sessionStorage.removeItem('idToken');
      return <Navigate to="/" replace />;
    }

    // Log groups claim for debugging (check browser console)
    const groups = payload['custom:groups'] || payload['cognito:groups'] || '';
    if (groups) console.log('[ProtectedRoute] user groups:', groups);
  } catch (e) {
    sessionStorage.removeItem('isAuthenticated');
    sessionStorage.removeItem('access_token');
    sessionStorage.removeItem('idToken');
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
